import SceneViewPage from './SceneViewPage.container'

export default SceneViewPage
